import React from 'react';
import { Heading } from '..';

import classNames from 'classnames';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaSnowflake, FaCouch, FaWind, FaHome, FaGamepad, FaBed, FaWater, FaVolumeMute } from 'react-icons/fa';

// import { MdPets } from 'react-icons/md';
import { GiWhistle } from 'react-icons/gi';
import { PiDog, PiDogFill } from 'react-icons/pi';
import { LuFence } from 'react-icons/lu';
import { MdWbIncandescent } from 'react-icons/md';
import { IoBed } from 'react-icons/io5';

const facilityDisplayData = {
  air_conditioned: {
    name: 'Air-Conditioned Rooms',
    icon: <FaSnowflake />,
  },
  indoor_play: {
    name: 'Indoor Play Area',
    icon: <FaHome />,
  },
  fenced_yard: {
    name: 'Fenced Yard',
    icon: <LuFence />,
  },
  group_play: {
    name: 'Group Play Sessions',
    icon: (
      <>
        <PiDogFill size={10} />
        <PiDog size={10} />
      </>
    ),
  },
  games: {
    name: 'Games & Activities',
    icon: <FaGamepad />,
  },
  nap_time: {
    name: 'Nap Time',
    icon: <FaBed />,
  },
  training_sessions: {
    name: 'Training Sessions',
    icon: <GiWhistle />,
  },
  splash_pool: {
    name: 'Splash Pool',
    icon: <FaWater />,
  },
  luxury_suits: {
    name: 'Luxury Suites',
    icon: <FaCouch />,
  },
  allergy_free: {
    name: 'Allergy-Free Zones',
    icon: <FaWind />,
  },
  ventilation_lighting: {
    name: 'Ventilation Lighting',
    icon: <MdWbIncandescent />,
  },
  bedding_blankets: {
    name: 'Bedding Blankets',
    icon: <IoBed />,
  },
  quiet_zones: {
    name: 'Quiet Zones',
    icon: <FaVolumeMute />,
  },
};

const SectionTopFacilities = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionTopFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.topFacilitiesList}>
        {selectedOptions.map(option => {
          const facility = facilityDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{facility?.icon}</span>
              <span>{facility?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionTopFacilities;
